module.exports = {"title":"What’s new with …?","subtitle":"Discover the latest improvements of the tool","latest-posts":"Latest posts","rss":"RSS feed"};